module.exports = __webpack_public_path__ + "img/Simple-Line-Icons.ttf?596814caa4fbaecbf5014bcfe8e363fb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plugins/simple-line-icons/fonts/Simple-Line-Icons.ttf
// module id = 602
// module chunks = 0